import { useEerieBackdrop } from "@/lib/eerie";
import { MatchKeyHost } from "@/components/MatchKey/MatchKeyShell";
import { CHESS_CFG } from "@/components/MatchKey/cfgs";

export default function ChessHostPage() {
  useEerieBackdrop("estampie");
  return <MatchKeyHost cfg={CHESS_CFG} />;
}
